import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '../styles/globals.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { initializeCsrf } from './api';

// Initialize CSRF token before rendering the app
initializeCsrf().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
});
